import log from 'loglevel';
const logger = log.getLogger('table-client');
export class QuoteParser {
    fieldDescriptors;
    parser;
    decoder = new TextDecoder('utf-8');
    constructor(fieldDescriptors) {
        this.fieldDescriptors = fieldDescriptors;
        if (fieldDescriptors)
            this.descriptors = fieldDescriptors;
        this.decoder; // use it so it doesn't tree-shake
    }
    get descriptors() {
        return this.fieldDescriptors;
    }
    set descriptors(descs) {
        this.fieldDescriptors = descs;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars -- used in eval
        const parsedValuesMap = new Map(descs.filter((x) => x.name && x.parsedValues).map((x) => [x.name, x.parsedValues]));
        let body = `
        const view = payload instanceof DataView ? payload : new DataView(payload.buffer, payload.byteOffset, payload.byteLength);
        let parsedValues, val;
        let tmpOffset, len;
        const acc = cache || {};

        `;
        for (const field of descs) {
            const { size, type, name, parsedValues, fieldOffset } = field;
            body += `
            // *** parsing ${name} of type ${type}
            `;
            switch (type) {
                // string with length
                case 'S':
                case 'K':
                case 'N':
                case 'X': {
                    body += `
                    tmpOffset = ${fieldOffset};
                    len = view.getUint16(tmpOffset, true); tmpOffset += 2;
                    if (len === 0) {
                        acc['${name}'] = '';
                    } else {
                        acc['${name}'] = this.decoder.decode(new DataView(view.buffer, view.byteOffset + tmpOffset, len));
                    }
                    `;
                    break;
                }
                // timestamp
                case 'T': {
                    body += `
                    acc['${name}'] = new Date(view.getFloat64(${fieldOffset}, true)); //
                    `;
                    break;
                }
                case 'E':
                case 'V':
                case 'F': {
                    if (size === 8) {
                        body += `
                        acc['${name}'] = view.getFloat64(${fieldOffset}, true);
                        `;
                    }
                    else {
                        body += `
                        acc[name] = view.getFloat32(${fieldOffset}, true);
                        `;
                    }
                    break;
                }
                // price
                case 'P':
                case 'L': {
                    body += `
                    acc['${name}'] = view.getFloat64(${fieldOffset}, true);
                    `;
                    break;
                }
                case 'I':
                case 'U':
                case '#':
                case 'Q':
                case 'B':
                case 'A':
                case 'M':
                case 'H': {
                    switch (size) {
                        case 1:
                            body += `
                            acc['${name}'] = view.getUint8(${fieldOffset});
                            `;
                            break;
                        case 2:
                            body += `
                            acc['${name}'] = view.getUint16(${fieldOffset}, true);
                            `;
                            break;
                        case 4:
                            body += `
                            acc['${name}'] = view.getUint32(${fieldOffset}, true);
                            `;
                            break;
                        case 8:
                            body += `
                            acc['${name}'] = view.getBigUint64(${fieldOffset}, true);
                            `;
                            break;
                    }
                    break;
                }
                case 'C': {
                    // buf.toString('ascii', fieldOffset, fieldOffset + 1);
                    body += `
                    acc['${name}'] = String.fromCharCode(view.getUint8(${fieldOffset})); 
                    `;
                    break;
                }
                default: {
                    logger.warn('ignoring field', name, 'of unknown type', type, 'and size', size);
                }
            }
            if (parsedValues) {
                /**
                 * unfortunatley parsedValues in quote server are not straightforward
                 * they could use 123h or h123 format
                 * as well as bitmasks e.g. value = 0a but parsedValues contains 2h and 8h
                 * see ./mock_data/quote-fields.ts
                 */
                //     body += `
                //     parsedValues = parsedValuesMap.get('${name}');
                //     `;
                //     body += `
                //     val = acc['${name}'];
                //     acc['${name}'] = parsedValues[val];
                //     if (acc['${name}'] === undefined) acc['${name}'] = parsedValues[\`'\${val}'\`]; // hack bugfix for now
                //     `;
            }
        }
        body += `
        return acc;
        `;
        this.parser = new Function(['parsedValuesMap', 'payload', 'cache'], body).bind(this, parsedValuesMap);
    }
    parse(payload, fields, cache) {
        if (fields !== this.descriptors)
            this.descriptors = fields;
        return this.parser(payload, cache);
    }
}
//# sourceMappingURL=quoteParser.js.map